import AdminLayout from '../../templates/AdminLayout';
import ClinicQRList from '../../UI/organisms/clinic/ClinicQRList';

const QRDashboardPage = () => {
  return <AdminLayout title={'QR 프로모션 참여 한의원 목록'} content={<ClinicQRList />} sideType={0} />;
};

export default QRDashboardPage;
